import type { Role, SessionRole } from '@/types/services/user'

export function roleToSessionRole(role: Role): SessionRole {
  return role == 'superadmin' ? 'admin' : role
}

export function isMultiEntityRole(role: SessionRole): boolean {
  return ['client', 'referral'].includes(role)
}
